import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';

const ErrorMessage = () => {
    return (
        <Card sx={{ 
            mt: 10, 
            minWidth: "20%",
            minHeight: "25vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
         }}>
            <CardContent>
                <Typography sx={{ fontSize: 24 }} color="error.main" gutterBottom>
                    Error retrieving request
                </Typography>
                <Typography sx={{ mb: 1.5 }} color="text.primary">
                    This creative has already been deactivated or rejected.
                </Typography>
            </CardContent>
        </Card>
    );
}

export default ErrorMessage;
